import { render } from "./AddAssessementQuestionsPage.vue?vue&type=template&id=21e8ff47"
import script from "./AddAssessementQuestionsPage.vue?vue&type=script&lang=js"
export * from "./AddAssessementQuestionsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__